import CustomButton from './CustomButton/CustomButton';

const HomeHero = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
  return (
    <section>
      <div className="card text-white border-0 hero-card ">
        {/* Responsive image wrapper with fixed height */}
        <div className="card-img-wrapper">
          <img src={`${awsImageBaseUrl}images/Rectangle_herobanner.png`} className="card-img rounded-0" alt="Hero Background" />
        </div>

        {/* Overlay Content */}
        <div className="card-img-overlay d-flex flex-column justify-content-end justify-content-lg-center align-items-center text-center hero-overlay">
          <img
            src={`${awsImageBaseUrl}images/BrandAcumen_Logo.png`}
            alt="Logo Graphic"
            className="img-fluid d-none d-lg-block col-md-4 col-lg-3"
            loading="lazy"
          />
          <h1 className="font-bold  display-5 mb-4 text-shadow text-uppercase">
            <span className="red-bottom-border">Brand Naming Is Our Superpower</span>
          </h1>
          <h2 className="font-bold mb-xl-4 text-2xl">
            Iconic brand names are in our DNA. Find out how we can help your brand soar to new heights.
          </h2>
          <CustomButton
            label="Work With Us"
            variant="red"
            size="small"
            href="/work-with-us"
          />
        </div>

      </div>
    </section>
  );
};

export default HomeHero;
